export default "__VITE_ASSET__CEOFVyx2__"